module.exports = __webpack_public_path__ + "img/close_black_24dp.7d170ab9.svg";